import ApplicationModel, { attr } from '../ApplicationModel';
import { type AssistantChatAttributes } from './generated/AssistantChatAttributes';
import { model } from '../modelBuilder';

interface AssistantChat extends AssistantChatAttributes {}

@model
class AssistantChat extends ApplicationModel {
  // Start auto-generated
  static typename: 'AssistantChat' = 'AssistantChat';
  get typename(): 'AssistantChat' {
    return 'AssistantChat';
  }

  static internalTypename: 'Assistant::Chat' = 'Assistant::Chat';
  get internalTypename(): 'Assistant::Chat' {
    return 'Assistant::Chat';
  }

  static inputType = 'ChatAttributes!';

  static filterType = 'ChatFilters';
  static filters = { id: '[ID!]', query: 'String' };

  static fields = {
    agent: attr({ readable: true }),
    createdAt: attr({ readable: true }),
    frozen: attr({ readable: true }),
    id: attr({ readable: true }),
    messagesCount: attr({ readable: true }),
    name: attr({ writable: true, readable: true }),
    safe: attr({ readable: true }),
    token: attr({ readable: true }),
    updatedAt: attr({ readable: true }),
    createdByUser: attr.belongsTo({ readable: true, typename: 'User' }),
    messages: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  async regenerateToken() {
    await ApplicationModel.client.mutate(
      `mutation RegenerateAssistantChatToken($id: ID!) {
assistantChatRegenerateToken(id: $id) {
chat {
token
}
}
}`,
      { variables: { id: this.id } }
    );
    return this.reload();
  }
}

export default AssistantChat;
